import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Field, reduxForm, FormSection } from 'redux-form';
import { _t } from "../util/Translator";
import * as AfeFields from "./AfeFields";
import * as Actions from "../actions";
import store from "../store";

class SearchForm extends Component {
  state = {};

  componentDidMount() {
    //store.dispatch(getLastJobs());
  }

  onSubmit = (formValues) => {
    store.dispatch(Actions.updateSearchJobsParams({
      keywords: formValues.keywords,
      localization: formValues.localization
    }));

    this.props.history.push('/jobs');
    
  }

  render() {
    const { handleSubmit, submitting } = this.props;

    return (
      <Fragment> 
        <form className="form" style={{margin: 'auto'}} onSubmit={handleSubmit(this.onSubmit)}>
          <div className="row">
              <div className="col-md-4 col-6 d-flex justify-content-center">
                <Field name="keywords" type="text" component={AfeFields.Input} placeholder={_t("home.keywords")} />
              </div>
              <div className="col-md-4 col-6 d-flex justify-content-center">
                <Field name="localization" type="text" component={AfeFields.Input} placeholder={_t("home.location")} />
              </div>
              <div className="col-md-4 col-6 d-flex justify-content-center">
                <div className="form-group w-100">
                  <button type="submit" className="btn btn-primary font-default-normal w-100" disabled={submitting}>{_t("home.search")}</button>
                </div>  
              </div>
          </div>
        </form>
      </Fragment>
    );
  }
}

const validate = values => {
  const errors = {}
  return errors;
}

const warn = values => {
  const warnings = {}
  return warnings;
}

const form = reduxForm({
  form: 'searchForm', // a unique identifier for this form
  validate, // <--- validation function given to redux-form
  warn // <--- warning function given to redux-form
})(SearchForm);

const mapStateToProps = (state, ownProps) => {
  return {
    initialValues: {}, 
    enableReinitialize: true
  };
};

export default connect(
  mapStateToProps,
  {
    
  }
)(form);
